import { Component, OnInit, ViewEncapsulation, OnDestroy, ChangeDetectorRef, HostListener, ViewChild, ElementRef, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormArray,
  NgForm,
} from "@angular/forms";
import type { AbstractControl, ValidationErrors } from "@angular/forms";
import { AppStateService } from "../../../core-module/services/app-state.service";
import type { CloEditorDraft } from "../../../core-module/services/app-state.service";
import { NgbModal, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { pairwise, startWith, Subject, Subscription, take, takeUntil } from 'rxjs';

import { restore } from "./../../../../assets/json/restoreTooltip.en";


import { ModalService } from "src/app/core-module/services/modal.service";
import { CloStateService } from "../../../core-module/services/state/clo-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";
import { GraphStateService } from "../../../core-module/services/state/graph-state.service";
@Component({
  standalone: false,
  selector: "app-clo",
  templateUrl: "./clo.component.html",
  styleUrls: ["./clo.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class CloComponent implements OnInit, OnDestroy {
  addForm: FormGroup;
  rows: FormArray;
  rowLength = 0;
  registerForm: FormGroup;
  submitted = false;
  activeIdString: LegacyAny = "1";
  checkValid = true;
  fewFieldValuePresent = false;
  dataToShow = [];
  Max;
  Steps;
  Initial;
  Final;
  hrs;
  alldefault = false;
  powerLevel;
  unsubscribe = new Subject<void>();
  isTableValuesChanged = false;
  isValuesNumericGenerated = false;
  tableValueSubmit = false;
  isNumericCreatedRows = false;
  isGraphUpdated = false;
  disableGraph = false;
  defaultColor = true;
  disableAddBtn = false;
  workingHrsValuesArr: LegacyAny = [];
  isAscending = false;
  isGraphDragUpdate = false;
  unsubscribeNumeric = new Subject<void>();
  enableCOnfigureFlow = false;
  menuState;
  menuPosition;
  menuPositionX;
  menuPositionY;
  menuWidth;
  menuHeight;
  windowWidth;
  windowHeight;
  selectedRow;
  disableAddAboveBtn = false;
  disableAddBelowBtn = false;
  disableNumericClear = true;
  unsubscribeGraphType = new Subject<void>();
  enableChecked = false;
  cloLite;
  showClo;
  activeHours;
  initialLevel;
  subscription;
  restoreText = restore;
  @ViewChild("contextMenu", { static: false }) contextMenu: ElementRef;
  graphRepresentationType = "";
  afterClearField = false;
  fileResponse: LegacyAny = {};
  count: LegacyAny;
  respVal: string;
  @Input() public cloSchema;
  graphData: Subscription;
  clonedDataToShow: LegacyAny[] = [];
  clearFields:boolean=false;
  // True while autoDetectNumericGenerator is rebuilding the table rows
  // from the numeric-generator inputs. Rows are added empty and only
  // populated later (via reInitializeValue / onSubmit), so during this
  // window `addForm.valid` is transiently false. We must NOT emit that
  // transient "invalid" state onto the CLO validity signal, otherwise
  // Standard-mode buttons flicker enabled→disabled→enabled and any
  // synchronous assertion (e.g. Playwright) catches the disabled window.
  private isPopulatingFromNumeric = false;
  getCloLoadFeatureFileConfigureSub: Subscription;
  constructor(

    private readonly fb: FormBuilder,
    private readonly modalService: ModalService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly appState: AppStateService,
    private readonly clo: CloStateService,
    private readonly featureDefaults: FeatureDefaultsStateService,
    private readonly graphState: GraphStateService
  ) {
    this.addForm = this.fb.group({});
    this.rows = this.fb.array([]);
  }

  ngOnInit() {
    this.appState.setCloPointsStepValue("0");
    this.getCloLoadFeatureFileConfigureSub = this.clo.getCloLoadFeatureFileConfigure.subscribe((response) => {
        if (response === "Configure_CLO") {
        this.enableCOnfigureFlow = true;
        const conf = this.appState.getConfigurationData();
            if (conf.resp.CLO) {
          const cloEnabled = conf.resp.CLO.CloEnabled;
                if (cloEnabled === true) {
            this.featureDefaults.setCloDefaultColor(false);
            this.alldefault = false;
          } else {
            const cloData = conf.resp.CLO;
            const numPoints = Object.keys(cloData).length - 1;

            if (numPoints === 16 && this.cloSchema) {
              let isDefaultConfig = true;
              for (let i = 1; i <= 16; i++) {
                const cloPoint = this.cloSchema["properties"]["CloPoint" + i];
                const loadedPoint = cloData["CloPoint" + i];

                if (loadedPoint && cloPoint) {
                  const expectedHour = (i === 1)
                    ? cloPoint["properties"]["Time"]["const"]
                    : cloPoint["properties"]["Time"]["default"];
                  const expectedPower = cloPoint["properties"]["Percentage"]["default"];

                  if (loadedPoint["Time"] !== expectedHour || loadedPoint["Percentage"] !== expectedPower) {
                    isDefaultConfig = false;
                    break;
                  }
                } else {
                  isDefaultConfig = false;
                  break;
                }
              }
              this.alldefault = isDefaultConfig;
              this.featureDefaults.setCloDefaultColor(isDefaultConfig);
            } else {
              this.alldefault = false;
              this.featureDefaults.setCloDefaultColor(false);
            }
          }
          this.graphState.setEnableGraph(cloEnabled);
          this.enableGraph(cloEnabled);
          this.enableChecked = cloEnabled;
          this.disableGraph = !Boolean(cloEnabled);
          // enableGraph(false) sets defaultColor=true unconditionally, which
          // overrides the isDefaultConfig computed from actual CLO point data.
          // Re-apply the correct value so that a DCF with CloEnabled=false
          // but non-default curve points is not incorrectly shown as default.
                this.defaultColor = this.alldefault;
          this.featureDefaults.setCloDefaultColor(this.alldefault);
          this.cdRef.markForCheck();
        }
      }
    });
    this.featureDefaults.getCloDefaultValue.subscribe((response) => {
      if (response == "valid") {
        this.disableGraph = false;
        this.setDefaultGraph("valid");
        this.defaultColor=true;
        this.featureDefaults.setCloDefaultValue(this.defaultColor);
        this.cdRef.markForCheck();
      }
    });

    // Prioritize SaveSetData over ConfigurationData to get latest configured values
    const saveSetData = this.appState.getSaveSetData();
    if (saveSetData && saveSetData['resp'] && saveSetData['resp']['CLO']) {
      this.fileResponse = saveSetData;
    } else {
      this.fileResponse = this.appState.getConfigurationData();
    }

    // Fallback: after a device read, `configurationData.resp.CLO` may have
    // been stripped (features flagged "orange" get their `resp` entry deleted
    // in supported-features to force a re-check flow), or the resolved CLO
    // payload may only carry `CloEnabled` without the CloPoint entries.
    // The full read payload is preserved in `saveReadValue`, so use that
    // whenever the current fileResponse does not contain a populated
    // `CloPoint1` (which is what the downstream initialiser checks for).
    const currentCloPayload = this.fileResponse?.['resp']?.['CLO'];
    const currentHasCloPoints = !!(currentCloPayload && currentCloPayload['CloPoint1'] != null);
    if (!currentHasCloPoints) {
      const saveReadValue = this.appState.getSaveReadValue();
      const readCloPayload = saveReadValue?.['CLO'];
      if (readCloPayload && readCloPayload['CloPoint1'] != null) {
        this.fileResponse = { resp: { CLO: readCloPayload } };
      }
    }

    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();

    let featIndex: number = 0;
    if (unSelectedFeat != null && Array.isArray(unSelectedFeat) && unSelectedFeat.length > 0) {
      unSelectedFeat.forEach((element) => {
        if (element != null && element["featureName"] != null && element["featureName"].toString().toUpperCase() === "CLO") {
          this.fileResponse = {};
          const CLOUnSelected: LegacyAny = element["featureParameters"][0];
          const clonewEditedData = {
            resp: {
              CLO: CLOUnSelected,
            },
          };
          this.fileResponse = clonewEditedData;
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
        } else {
          featIndex++;
        }
      });
    }


    this.dataToShow = [];
    this.rows.clear();
    this.defaultColor = true;

    this.graphState.getGraphRepresentation
      .pipe(takeUntil(this.unsubscribeGraphType))
      .subscribe((data) => {
        if (data != "") {
          this.graphRepresentationType = data;
          this.graphState.sendCloGraphData(
            this.graphRepresentationType,
            this.dataToShow
          );
          this.cdRef.markForCheck();
        }
      });

    this.addForm.addControl("rows", this.rows);
    this.rowLength = this.rows.length;

    // Guard: Ensure cloSchema is loaded before creating form validators
    if (!this.cloSchema || !this.cloSchema["properties"] ||
        !this.cloSchema["properties"]["CloPoint1"] ||
        !this.cloSchema["properties"]["CloPoint16"]) {
      // Create a minimal form to prevent template errors
      this.registerForm = this.fb.group({
        cloHour: ["", [Validators.required, Validators.pattern("^[0-9]*$")]],
        cloSteps: ["", [Validators.required, Validators.pattern("^[0-9]*$"), Validators.min(1), Validators.max(16)]],
        initialOutput: ["", [Validators.required, Validators.pattern("^[0-9]*$")]],
        finalOutput: ["", [Validators.required, Validators.pattern("^[0-9]*$")]],
      });
      return;
    }

    this.registerForm = this.fb.group({
      cloHour: [
        "",
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.min(1),
          Validators.max(
            this.cloSchema["properties"]["CloPoint16"]["properties"]["Time"][
            "maximum"
            ]
          ),
        ],
      ],
      cloSteps: [
        "",
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.min(1),
          Validators.max(16),
        ],
      ],
      initialOutput: [
        "",
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.min(1),
          Validators.max(
            this.cloSchema["properties"]["CloPoint16"]["properties"][
            "Percentage"
            ]["maximum"]
          ),
        ],
      ],
      finalOutput: [
        "",
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.min(1),
          Validators.max(
            this.cloSchema["properties"]["CloPoint16"]["properties"][
            "Percentage"
            ]["maximum"]
          ),
        ],
      ],
    });

    this.subscription = this.clo.getCloHead.subscribe((data) => {
      if (data === "Clo") {
        this.showClo = true;
      }
    });
    this.f.cloHour.valueChanges
      .pipe(takeUntil(this.unsubscribeNumeric))
      .subscribe((data) => {
        if (data !== "") {
          this.autoDetectNumericGenerator();
        }
      });
    this.f.cloSteps.valueChanges
      .pipe(takeUntil(this.unsubscribeNumeric))
      .subscribe((data) => {
        if (data !== "") {
          this.appState.setCloPointsStepValue(String(data));
          this.autoDetectNumericGenerator();
        }
      });
    this.f.initialOutput.valueChanges
      .pipe(takeUntil(this.unsubscribeNumeric))
      .subscribe((data) => {
        if (data !== "") {
          this.autoDetectNumericGenerator();
        }
      });
    this.f.finalOutput.valueChanges
      .pipe(takeUntil(this.unsubscribeNumeric))
      .subscribe((data) => {
        if (data !== "") {
          this.autoDetectNumericGenerator();
        }
      });

    const editorDraft = this.appState.takeCloEditorDraft();
    if (editorDraft) {
      this.restoreEditorDraft(editorDraft);
    } else if (
      this.fileResponse &&
      this.fileResponse["resp"] &&
      this.fileResponse["resp"]["CLO"] &&
      this.fileResponse["resp"]["CLO"]["CloPoint1"] != null
    ) {
        setTimeout(() => {
        this.clearAllValidators();
      }, 10);
      if (this.fileResponse["resp"]["CLO"]) {
        const cloData = this.fileResponse["resp"]["CLO"];
        const cloEnabled = cloData["CloEnabled"];
        const numPoints = Object.keys(cloData).length - 1; // Subtract 1 for CloEnabled

        let hasNonDefaultValues = false;
        let isDefaultConfig = true;

        // Check if values are non-default
        if (numPoints === 16 && this.cloSchema) {
          for (let i = 1; i <= 16; i++) {
            const cloPoint = this.cloSchema["properties"]["CloPoint" + i];
            const loadedPoint = cloData["CloPoint" + i];

            if (loadedPoint && cloPoint) {
              const expectedHour = (i === 1)
                ? cloPoint["properties"]["Time"]["const"]
                : cloPoint["properties"]["Time"]["default"];
              const expectedPower = cloPoint["properties"]["Percentage"]["default"];

              if (loadedPoint["Time"] !== expectedHour || loadedPoint["Percentage"] !== expectedPower) {
                isDefaultConfig = false;
                hasNonDefaultValues = true;
                break;
              }
            } else {
              isDefaultConfig = false;
              break;
            }
          }
        } else if (numPoints === 1 && this.cloSchema) {
          // Check if the single point is CloPoint1 with default values
          const cloPoint1 = this.cloSchema["properties"]["CloPoint1"];
          const loadedPoint1 = cloData["CloPoint1"];

          if (loadedPoint1 && cloPoint1) {
            const expectedHour = cloPoint1["properties"]["Time"]["const"];
            const expectedPower = cloPoint1["properties"]["Percentage"]["default"];

            if (loadedPoint1["Time"] === expectedHour && loadedPoint1["Percentage"] === expectedPower) {
              isDefaultConfig = true;
              hasNonDefaultValues = false;
            } else {
              isDefaultConfig = false;
              hasNonDefaultValues = true;
            }
          } else {
            isDefaultConfig = false;
            hasNonDefaultValues = false;
          }
        } else if (numPoints > 0) {
          // If not exactly 16 or 1 point but has data, treat as non-default
          isDefaultConfig = false;
          hasNonDefaultValues = true;
        }

        // Respect an explicit CloEnabled flag from the device/configuration.
        // Only fall back to inferring from non-default values when CloEnabled
        // is missing (e.g. some imported DCF files) so an explicit user
        // uncheck of "Enable feature" is not silently re-enabled on Read.
        const shouldEnableFeature =
          typeof cloEnabled === "boolean"
            ? cloEnabled
            : (cloEnabled || hasNonDefaultValues);
        this.enableChecked = shouldEnableFeature;

        if (shouldEnableFeature) {
          this.disableGraph = false;
          this.defaultColor = false;
          this.alldefault = false;
          this.graphState.setEnableGraph(true);
        } else {
          this.disableGraph = true;
          this.defaultColor = isDefaultConfig;
          this.alldefault = isDefaultConfig;
          this.graphState.setEnableGraph(false);
        }

        const calculatedDefaultColor = this.defaultColor;
        const calculatedAllDefault = this.alldefault;

        this.autoDetectNumericGenerator();
        this.fileResponse = "";

        setTimeout(() => {
          this.defaultColor = calculatedDefaultColor;
          this.alldefault = calculatedAllDefault;
                this.featureDefaults.setCloDefaultColor(this.defaultColor);
          this.setAllValidators();
          this.applyGraphDisabledState();
        }, 100);
      }
    } else {
        for (let i = 1; i <= 16; i++) {
        this.onAddRow();
      }

      for (let i = 1; i <= 16; i++) {
        const cloPoint = this.cloSchema["properties"]["CloPoint" + i];
        if (cloPoint && this.rows.controls[i - 1]) {
          const workingHoursValue = (i === 1)
            ? cloPoint["properties"]["Time"]["const"]
            : cloPoint["properties"]["Time"]["default"];
          this.rows.controls[i - 1]["controls"].workingHours.setValue(workingHoursValue);
          this.rows.controls[i - 1]["controls"].outputLevel.setValue(
            cloPoint["properties"]["Percentage"]["default"]
          );
          this.dataToShow.push({
            hour: workingHoursValue,
            power: cloPoint["properties"]["Percentage"]["default"],
          });
        }
      }

      // Initialize graph to disabled state with default values
      this.enableChecked = false;
      this.disableGraph = true;
      this.defaultColor = true;
      this.alldefault = true;
      this.graphState.setEnableGraph(false);

      for (let i = 0; i < this.rows.length; i++) {
        this.checkAddesRowValuesChanged(i);
      }
      this.graphState.sendGraphIsEditedData(this.dataToShow);
      this.graphState.sendCloGraphData(
        this.graphRepresentationType,
        this.dataToShow
      );
      this.applyGraphDisabledState();
    }
    //Numeric Generator Values Auto Detect - Ends Here

    this.graphState.getChangedGraphData.subscribe((data) => {
      //change rows when drag graph changes -start here
      if (this.registerForm.valid) {
        this.isNumericCreatedRows = true;
      }
      if (data.length) {
        if (this.isGraphUpdated && this.isNumericCreatedRows) {
          this.confirmGraphChangeValues(data);
        }
        if (!this.isGraphUpdated && this.isNumericCreatedRows) {
          this.confirmGraphChangeValues(data);
        } else {
          if (!this.isNumericCreatedRows) {
            this.updateGraphDataToTable(data);
          }
        }
      }
    }); //change rows when drag graph changes -ends here
    this.featureDefaults.setCloDefaultColor(this.defaultColor);

    // (Previously a 5s setTimeout branched on enableCOnfigureFlow with no body  removed.)

    this.checkActualCloPoints();

    this.checkFinalDefaultTable();

    setTimeout(() => {
      this.checkWorkingHrsValuesOrder(0);
      this.setCloValid(this.addForm.valid ? "valid" : "invalid");
    }, 100);
  }
  private hasNumericGeneratorInput(): boolean {
    if (!this.registerForm) {
      return false;
    }
    return Object.keys(this.registerForm.controls).some(key => {
      const value = this.registerForm.controls[key].value;
      return value !== '' && value != null;
    });
  }

  private hasInvalidCloInput(): boolean {
    return !this.addForm.valid || (this.hasNumericGeneratorInput() && this.registerForm.invalid);
  }

  checkFinalDefaultTable() {
    if (this.rows.length !== 16 || this.hasInvalidCloInput()) {
      this.defaultColor = false;
      this.alldefault = false;
      this.featureDefaults.setCloDefaultColor(false);
      return;
    }

    if (this.rows.length === 16 && !this.enableChecked) {
      let isAllDefault = true;
      for (let i = 0; i < 16; i++) {
        const wH = this.rows.controls[i]["controls"].workingHours.value;
        const oL = this.rows.controls[i]["controls"].outputLevel.value;
        const cloPoint = this.cloSchema["properties"]["CloPoint" + (i + 1)];

        if (cloPoint) {
          const expectedHour = (i === 0)
            ? cloPoint["properties"]["Time"]["const"]
            : cloPoint["properties"]["Time"]["default"];
          const expectedPower = cloPoint["properties"]["Percentage"]["default"];

          if (Number(wH) !== expectedHour || Number(oL) !== expectedPower) {
            isAllDefault = false;
            break;
          }
        } else {
          isAllDefault = false;
          break;
        }
      }

      this.defaultColor = isAllDefault;
      this.alldefault = isAllDefault;
        this.featureDefaults.setCloDefaultColor(isAllDefault);
    }

    if (this.enableChecked === true) {
      this.defaultColor = false;
      this.alldefault = false;
        this.featureDefaults.setCloDefaultColor(false);
    }
  }
  checkActualCloPoints() {
    this.appState.removeCloPoints();
    const cloPointsAdded = this.rows.length;
    this.appState.setCloPoints(String(cloPointsAdded));
  }

  /**
   * Emits the CLO form validity to both the shared graph-validity signal
   * (kept for backward compatibility with graph rendering and CLO-Lite
   * legacy wiring) AND to a dedicated CLO-only signal on CloStateService.
   *
   * The dedicated signal is what feature-supported / feature-init use to
   * derive `isClo`. This isolates CLO's validity from unrelated emissions
   * by other components (CLO-Lite, Dyna Dimmer) that also write into
   * graphState.sendGraphValidData, which previously caused the Save /
   * Configure buttons to remain enabled in Standard mode.
   */
  private setCloValid(data: string): void {
    const effective = this.disableGraph ? (this.hasInvalidCloInput() ? 'invalid' : 'valid')
    : (this.hasNumericGeneratorInput() && this.registerForm.invalid ? 'invalid' : data);
    this.graphState.sendGraphValidData(effective);
    this.clo.sendCloFormValid(effective);
    // Most emissions happen in timers; mark ancestors (OnPush) so Save/Configure re-render.
    this.cdRef.markForCheck();
  }
  setAllValidators() {
    if (this.showClo) {
      this.registerForm.controls["cloSteps"].setValidators([
        Validators.required,
        Validators.pattern("^[0-9]*$"),
        Validators.min(1),
        Validators.max(16),
      ]);
      this.registerForm.controls["finalOutput"].setValidators([
        Validators.required,
        Validators.pattern("^[0-9]*$"),
        Validators.min(1),
        Validators.max(
          this.cloSchema["properties"]["CloPoint16"]["properties"][
          "Percentage"
          ]["maximum"]
        ),
      ]);
      this.registerForm.controls["initialOutput"].setValidators([
        Validators.required,
        Validators.pattern("^[0-9]*$"),
        Validators.min(1),
        Validators.max(
          this.cloSchema["properties"]["CloPoint16"]["properties"][
          "Percentage"
          ]["maximum"]
        ),
      ]);
      this.registerForm.controls["cloHour"].setValidators([
        Validators.required,
        Validators.pattern("^[0-9]*$"),
        Validators.min(1),
        Validators.max(
          this.cloSchema["properties"]["CloPoint16"]["properties"]["Time"][
          "maximum"
          ]
        ),
      ]);
    }
  }
  clearAllValidators() {
    const closteps = this.registerForm.get("cloSteps");
    const cloFinal = this.registerForm.get("finalOutput");
    const initialOutput = this.registerForm.get("initialOutput");
    const cloHour = this.registerForm.get("cloHour");

    closteps.clearValidators();
    closteps.updateValueAndValidity();

    cloFinal.clearValidators();
    cloFinal.updateValueAndValidity();

    initialOutput.clearValidators();
    initialOutput.updateValueAndValidity();

    cloHour.clearValidators();
    cloHour.updateValueAndValidity();

    this.checkActualCloPoints();
  }
  checkValidator() {
    setTimeout(() => {
      const closteps = this.registerForm.controls["cloSteps"];
      const cloFinal = this.registerForm.controls["finalOutput"];
    }, 100);
  }
  autoDetectNumericGenerator() {
    //Numeric Generator Values Auto Detect - Starts Here
    setTimeout(() => {
      this.checkValidator();
      this.disableNumericClear = false;
      if (
        this.registerForm.valid ||
        (this.fileResponse["resp"] && this.fileResponse["resp"]["CLO"])
      ) {
        // Suppress transient "invalid" emissions from onAddRow() while
        // this loop builds up the table rows. Rows are added empty here
        // and their values are only populated later (via reInitializeValue
        // / onSubmit / manual editing), so treating the transient empty
        // state as CLO-invalid causes Standard-mode Save / Configure
        // buttons to flicker disabled between the numeric-generator emit
        // and the settled state emit below.
        this.isPopulatingFromNumeric = true;
        this.Max = Number(this.f.cloHour.value);
        if (this.fileResponse["resp"] && this.fileResponse["resp"]["CLO"]) {
          this.Steps = Object.keys(this.fileResponse["resp"]["CLO"]).length - 1;
        } else {
          this.Steps = Number(this.f.cloSteps.value);
        }
        this.Initial = Number(this.f.initialOutput.value);
        this.Final = Number(this.f.finalOutput.value);
        this.dataToShow = [];

        if (!this.alldefault && (this.f.cloHour.value || this.f.cloSteps.value || this.f.initialOutput.value || this.f.finalOutput.value)) {
          this.defaultColor = false;
          this.featureDefaults.setCloDefaultColor(this.defaultColor);
        }

        if (this.Steps !== 1) {
          let prevHour = null;
          let prevpowerLevel = null;
          for (let n = 0; n <= this.Steps - 1; n++) {
            this.onAddRow();
            if (this.fileResponse["resp"]) {
              if (
                this.fileResponse["resp"]["CLO"] &&
                this.fileResponse["resp"]["CLO"]["CloPoint" + [n + 1]]
              ) {
                this.dataToShow.push({
                  hour: this.fileResponse["resp"]["CLO"]["CloPoint" + [n + 1]][
                    "Time"
                  ],
                  power:
                    this.fileResponse["resp"]["CLO"]["CloPoint" + [n + 1]][
                    "Percentage"
                    ],
                });
              } else {
                this.hrs = Math.round(
                  0 + (n * (this.Max - 0)) / (this.Steps - 1)
                );
                this.powerLevel = Math.floor(
                  this.Initial +
                  (n * (this.Final - this.Initial)) / (this.Steps - 1)
                );
                if (prevHour != null && this.hrs === prevHour) {
                  this.powerLevel = prevpowerLevel;
                }
                prevHour = this.hrs;
                prevpowerLevel = this.powerLevel;
                this.dataToShow.push({
                  hour: this.hrs,
                  power: this.powerLevel,
                });
              }
            } else {
              this.hrs = Math.round(
                0 + (n * (this.Max - 0)) / (this.Steps - 1)
              );
              this.powerLevel = Math.floor(
                this.Initial +
                (n * (this.Final - this.Initial)) / (this.Steps - 1)
              );
              if (prevHour != null && this.hrs === prevHour) {
                this.powerLevel = prevpowerLevel;
              }
              prevHour = this.hrs;
              prevpowerLevel = this.powerLevel;
              this.dataToShow.push({
                hour: this.hrs,
                power: this.powerLevel,
              });
            }
          }
        }
        if (this.Steps === 1) {
          for (let n = 0; n <= this.Steps - 1; n++) {
            this.onAddRow();
            if (this.fileResponse["resp"]) {
              if (this.fileResponse["resp"]["CLO"]) {
                this.dataToShow.push({
                  hour: this.fileResponse["resp"]["CLO"]["CloPoint" + [n + 1]][
                    "Time"
                  ],
                  power:
                    this.fileResponse["resp"]["CLO"]["CloPoint" + [n + 1]][
                    "Percentage"
                    ],
                });
              } else {
                this.hrs = Math.round(0 + n * (this.Max - 0));
                this.powerLevel = Math.floor(
                  this.Initial + n * (this.Final - this.Initial)
                );
                this.dataToShow.push({
                  hour: this.hrs,
                  power: this.powerLevel,
                });
              }
            } else {
              this.hrs = Math.round(0 + n * (this.Max - 0));
              this.powerLevel = Math.floor(
                this.Initial + n * (this.Final - this.Initial)
              );
              this.dataToShow.push({
                hour: this.hrs,
                power: this.powerLevel,
              });
            }
          }
        }
        this.graphState.sendGraphIsEditedData(this.dataToShow);
        this.graphState.sendCloGraphData(
          this.graphRepresentationType,
          this.dataToShow
        );
        //this.checkActualCloPoints();
        this.isPopulatingFromNumeric = false;
        // Emit the settled CLO validity immediately after the row-build
        // loop finishes so Standard-mode buttons reflect the correct
        // state on the same tick as the user's keystroke, instead of
        // waiting on the 100 ms setTimeout below (which was the source
        // of the "buttons only enable after blur" race).
        if (this.registerForm.valid) {
          this.setCloValid("valid");
        }
      }
    }, 0);
    setTimeout(() => {
      if (this.registerForm.valid) {
        this.setCloValid("valid");
      }
    }, 100);
    if (this.fileResponse["resp"]) {
      if (this.fileResponse["resp"]["CLO"]) {
        const evt = {
          activeId: "1",
          nextId: "2",
        };
        this.onSubmit(evt);
        this.activeIdString = "2";
        // Show red borders for LegacyAny out-of-range values loaded from device
        this.tableValueSubmit = true;
      }
    }
    this.afterClearField = false;
  } //Numeric Generator Values Auto Detect - Ends Here

  confirmGraphChangeValues(data) {
    this.modalService.confirm('Values are changed from the numeric generator. Are you sure you want to proceed', "Confirm", true).pipe(take(1))
      .subscribe(confirm => {
        if (confirm) {
          this.updateGraphDataToTable(data);
        } else {
          this.dataToShow = [];
          for (let n = 0; n <= this.Steps - 1; n++) {
            this.hrs = Math.round(0 + (n * (this.Max - 0)) / (this.Steps - 1));
            this.powerLevel = Math.floor(
              this.Initial + (n * (this.Final - this.Initial)) / (this.Steps - 1)
            );
            this.dataToShow.push({ hour: this.hrs, power: this.powerLevel });
          }
          this.graphState.sendCloGraphData(
            this.graphRepresentationType,
            this.dataToShow
          );
          if (!this.isNumericCreatedRows) {
            this.rows.clear();
            this.dataToShow.forEach((content, index) => {
              this.onAddRow();
              this.checkAddesRowValuesChanged(index);
            });
            // Check if the values are default or non-default
            setTimeout(() => {
              this.checkFinalDefaultTable();
            }, 150);
          }
        }
        this.checkActualCloPoints();

      }
    );



  }

  updateGraphDataToTable(data) {
    this.checkValidator();
    this.isNumericCreatedRows = false;
    this.unsubscribe.next(undefined);
    this.dataToShow = [];
    // Limit to maximum 16 timeslots
    const limitedData = data.slice(0, 16);
    limitedData.forEach((content, index) => {
      this.dataToShow.push({
        hour: Math.round(content.hour),
        power: Math.floor(content.power),
      });
    });
    this.isGraphUpdated = true;
    if (this.showClo) {
      this.reInitializeValue();
    }
    //Drag Invalid Data Check - starts here
    this.dataToShow.forEach((content, index) => {
      if (index !== this.dataToShow.length - 1) {
        if (this.dataToShow[index].hour > this.dataToShow[index + 1].hour) {
          setTimeout(() => {
            if (this.rows.controls[index + 1]) {
              this.rows.controls[index + 1]["controls"].workingHours.setErrors({
                incorrect: true,
              });
              this.setCloValid("invalid");
              this.disableAddBtn = true;
            }
          }, 0);
        }
      }
      this.checkActualCloPoints();
    });
    //Drag Invalid Data Check - ends here
    this.isNumericCreatedRows = false;
    if (this.showClo) {
      for (const key of Object.keys(this.f)) {
        this.f[key].setValue("");
      }
    }
    this.isTableValuesChanged = true;
    this.isGraphDragUpdate = true;
    this.graphState.getGraphRepresentation
      .pipe(takeUntil(this.unsubscribeGraphType))
      .subscribe((data) => {
        if (data != "") {
          this.graphRepresentationType = data;
          this.graphState.sendCloGraphData(
            this.graphRepresentationType,
            this.dataToShow
          );
        }
      });
    this.checkActualCloPoints();
    // Check if the updated values are default or non-default
    setTimeout(() => {
      this.checkFinalDefaultTable();
    }, 150);
  }

  tabChanged($event: NgbNavChangeEvent) {
    if ($event.nextId === "1") {
      this.isNumericCreatedRows = false;
    }
    if ($event.nextId === "2") {
      if (
        this.registerForm.valid ||
        (this.fileResponse["resp"] && this.fileResponse["resp"]["CLO"])
      ) {
        this.isValuesNumericGenerated = true;
      }
      this.onSubmit($event);
    }
    this.fileResponse = "";
    if (this.isNumericCreatedRows) {
      this.defaultColor = false;
    }
    this.featureDefaults.setCloDefaultColor(this.defaultColor);

  }

  get f() {
    return this.registerForm.controls;
  }

  onSubmit($event?) {
    this.submitted = false;
    this.checkIfValueEntered();
    if (this.isTableValuesChanged !== true) {
      if (this.fewFieldValuePresent === true && this.registerForm.invalid) {
        //one of the values entered
        // Some callers (e.g. autoDetectNumericGenerator) pass a plain
        // { activeId, nextId } object instead of a DOM/NgbNav event, so
        // preventDefault may be missing.
        if ($event && typeof $event.preventDefault === "function") {
          $event.preventDefault();
        }
        this.confirmResetFields();
      } else {
        //No Values given
        if (!this.dataToShow.length) {
          //If value entered in table values retain it on tab change
          this.rows.clear();
          this.onAddRow();
          this.dataToShow = [];
          this.dataToShow.push({
            hour: this.cloSchema["properties"]["CloPoint1"]["properties"][
              "Time"
            ]["const"],
            power:
              this.cloSchema["properties"]["CloPoint1"]["properties"][
              "Percentage"
              ]["default"],
          });
          this.rows.controls[0]["controls"].workingHours.setValue(
            this.cloSchema["properties"]["CloPoint1"]["properties"]["Time"][
            "const"
            ]
          );
          this.rows.controls[0]["controls"].outputLevel.setValue(
            this.cloSchema["properties"]["CloPoint1"]["properties"][
            "Percentage"
            ]["default"]
          );

          this.checkAddesRowValuesChanged(this.rows.length - 1);
          setTimeout(() => {
            this.isTableValuesChanged = false;
          }, 0);
          this.defaultColor = true;
          this.featureDefaults.setCloDefaultColor(this.defaultColor);

          this.graphState.sendGraphIsEditedData([
            {
              hour: this.cloSchema["properties"]["CloPoint1"]["properties"][
                "Time"
              ]["const"],
              power:
                this.cloSchema["properties"]["CloPoint1"]["properties"][
                "Percentage"
                ]["default"],
            },
          ]);
          this.graphState.sendCloGraphData(
            this.graphRepresentationType,
            this.dataToShow
          );
        }
      }
    }

    if (
      this.registerForm.valid ||
      (this.fileResponse["resp"] &&
        this.fileResponse["resp"]["CLO"] &&
        this.fileResponse["resp"]["CLO"]["CloPoint1"])
    ) {
      this.isGraphUpdated = true;
      this.unsubscribe.next(undefined); //clear rows on changing between tabs once numeric generated - starts here
      this.isNumericCreatedRows = false;
      this.rows.clear();
      this.dataToShow = [];
      this.Max = Number(this.f.cloHour.value);
      if (this.fileResponse["resp"] && this.fileResponse["resp"]["CLO"]) {
        this.Steps = Object.keys(this.fileResponse["resp"]["CLO"]).length - 1;
      } else {
        this.Steps = Number(this.f.cloSteps.value);
      }
      this.Initial = Number(this.f.initialOutput.value);
      this.Final = Number(this.f.finalOutput.value);
      this.dataToShow = [];
      if (this.Steps !== 1) {
        let prevHour = null;
        let prevpowerLevel = null;
        for (let n = 0; n <= this.Steps - 1; n++) {
          this.onAddRow();
          if (this.fileResponse["resp"]) {
            if (
              this.fileResponse["resp"]["CLO"] &&
              this.fileResponse["resp"]["CLO"]["CloPoint" + [n + 1]]
            ) {
              this.dataToShow.push({
                hour: this.fileResponse["resp"]["CLO"]["CloPoint" + [n + 1]][
                  "Time"
                ],
                power:
                  this.fileResponse["resp"]["CLO"]["CloPoint" + [n + 1]][
                  "Percentage"
                  ],
              });
            } else {
              this.hrs = Math.round(
                0 + (n * (this.Max - 0)) / (this.Steps - 1)
              );
              this.powerLevel = Math.floor(
                this.Initial +
                (n * (this.Final - this.Initial)) / (this.Steps - 1)
              );
              if (prevHour != null && this.hrs === prevHour) {
                this.powerLevel = prevpowerLevel;
              }
              prevHour = this.hrs;
              prevpowerLevel = this.powerLevel;
              this.dataToShow.push({ hour: this.hrs, power: this.powerLevel });
            }
          } else {
            this.hrs = Math.round(0 + (n * (this.Max - 0)) / (this.Steps - 1));
            this.powerLevel = Math.floor(
              this.Initial +
              (n * (this.Final - this.Initial)) / (this.Steps - 1)
            );
            if (prevHour != null && this.hrs === prevHour) {
              this.powerLevel = prevpowerLevel;
            }
            prevHour = this.hrs;
            prevpowerLevel = this.powerLevel;
            this.dataToShow.push({ hour: this.hrs, power: this.powerLevel });
          }
        }
        setTimeout(() => {
          for (let n = 0; n <= this.Steps - 1; n++) {
            this.checkAddesRowValuesChanged(n);
          }
        }, 10);
      }
      if (this.Steps === 1) {
        for (let n = 0; n <= this.Steps - 1; n++) {
          this.onAddRow();
          if (this.fileResponse["resp"]) {
            if (this.fileResponse["resp"]["CLO"]) {
              this.dataToShow.push({
                hour: this.fileResponse["resp"]["CLO"]["CloPoint" + [n + 1]][
                  "Time"
                ],
                power:
                  this.fileResponse["resp"]["CLO"]["CloPoint" + [n + 1]][
                  "Percentage"
                  ],
              });

            } else {
              this.hrs = Math.round(0 + n * (this.Max - 0));
              this.powerLevel = Math.floor(
                this.Initial + n * (this.Final - this.Initial)
              );
              this.dataToShow.push({ hour: this.hrs, power: this.powerLevel });
            }
          } else {
            this.hrs = Math.round(0 + n * (this.Max - 0));
            this.powerLevel = Math.floor(
              this.Initial + n * (this.Final - this.Initial)
            );
            this.dataToShow.push({ hour: this.hrs, power: this.powerLevel });
          }
        }
        setTimeout(() => {
          for (let n = 0; n <= this.Steps - 1; n++) {
            this.checkAddesRowValuesChanged(n);
          }
        }, 10);
        this.isNumericCreatedRows = true;
      }
      setTimeout(() => {
        if (this.rowLength === 16) {
          this.disableAddBtn = true;
        } else {
          this.disableAddBtn = false;
        }
      }, 0);

      this.graphState.sendGraphIsEditedData(this.dataToShow);
      this.reInitializeValue();
      this.verifyTableValueChange();
      this.checkActualCloPoints();
      // Check if the populated values are default or non-default
      setTimeout(() => {
        this.checkFinalDefaultTable();
      }, 150);
    }
    if (this.submitted === false) {
      this.setCloValid(this.addForm.valid ? "valid" : "invalid");
    }
  }

  inputValueChanged($event) {
    this.fewFieldValuePresent = false;
    const key = $event?.key;
    const isAlphabetKey = key != null && key.length === 1 && !/[0-9]/.test(key);
    const isDeletion = key === "Backspace" || key === "Delete";
    if (!isDeletion && !this.hasNumericGeneratorInput()) {
      // Generator unused (e.g. tabbing through empty fields): validity follows the table only.
      this.submitted = false;
      this.setCloValid(this.addForm.valid ? "valid" : "invalid");
      return;
    }
    if (key !== "Tab" && !isAlphabetKey) {
      this.submitted = true;
    }
    this.alldefault = false;
    if (isDeletion) {
      this.submitted = false;
      this.checkIfValueEntered();
      if (this.fewFieldValuePresent === false) {
        this.defaultColor = !this.enableChecked;
        this.setCloValid("valid");
      } else {
        this.handleFormValidation();
      }
    } else {
      this.handleFormValidation();
    }
    this.featureDefaults.setCloDefaultColor(this.defaultColor);
  }

  private handleFormValidation() {
    this.defaultColor = false;
    if (this.registerForm.invalid) {
      this.setCloValid("invalid");
    } else if (this.registerForm.valid) {
      this.setCloValid("valid");
    }
    this.featureDefaults.setCloDefaultColor(this.defaultColor);
  }

  onAddRow(restoreDefaultStatus = "default") {
    // Check if already at maximum limit before adding
    if (this.rows.length >= 16) {
      this.disableAddBtn = true;
      return;
    }

    if (restoreDefaultStatus === 'valid') {
      // During restore-to-defaults, don't emit false Ã¢‚¬€ setDefaultGraph will
      // emit the correct final default color after all rows are rebuilt.
      this.defaultColor = false;
    } else if (this.alldefault) {
      this.defaultColor = true;
      this.featureDefaults.setCloDefaultColor(this.defaultColor);
    }

    if (!this.isNumericCreatedRows) {
      this.rows.push(this.createItemFormGroup());
      this.rowLength = this.rows.length;
    }
    if (this.isNumericCreatedRows) {

      this.modalService.confirm('Values are changed from the numeric generator. Are you sure you want to proceed', "Confirm", true).pipe(take(1))
        .subscribe(confirm => {
          if (confirm) {
            this.unsubscribe.next(undefined);
            this.isNumericCreatedRows = false;
            this.rows.push(this.createItemFormGroup());
            this.rowLength = this.rows.length;
            for (const key of Object.keys(this.f)) {
              this.f[key].setValue("");
            }
            this.submitted = false;
            this.isTableValuesChanged = true;
            this.alldefault = false;
            this.checkAddesRowValuesChanged(this.rows.length - 1);
            this.checkActualCloPoints();
          } else {
            return;
          }

        }
      );
    }

    if (restoreDefaultStatus === 'valid' || this.clearFields) {
      setTimeout(() => {
        this.syncOnAddRowDisableAndValidity();
        this.clearFields = false;
      }, 0);

    } else {
      this.syncOnAddRowDisableAndValidity();
    }


    this.checkActualCloPoints();

  }

  // Shared body for both onAddRow tail branches — see LETSSYS-9005 (44 dup lines).
  private syncOnAddRowDisableAndValidity(): void {
    this.disableAddBtn = this.rowLength === 16;
    if (!this.addForm.valid) {
      this.disableAddBtn = true;
      if (!this.isPopulatingFromNumeric) {
        this.setCloValid("invalid");
      }
    } else {
      this.disableAddBtn = false;
      this.setCloValid("valid");
    }
  }
  //Enter Table Invalid Data Check - starts here
  checkWorkingHrsValuesOrder(position) {
    this.workingHrsValuesArr = [];
    this.rows.controls.forEach((content, index) => {
      content.get('workingHours')?.updateValueAndValidity({ emitEvent: false });
      if (index !== this.dataToShow.length) {
        this.workingHrsValuesArr.push(+content.value.workingHours);
      }
    });
    this.isAscending = true;
    this.workingHrsValuesArr.forEach((content, index) => {
      if (index == 0 && content > 0) {
        this.rows.controls[index]["controls"].workingHours.setErrors({
          incorrect: true,
        });
      }
      if (
        this.workingHrsValuesArr[index] < 0 ||
        this.workingHrsValuesArr[index] > 120
      ) {
        this.rows.controls[index]["controls"].workingHours.setErrors({
          incorrect: true,
        });
      }
      if (
        !this.rows.controls[index]["controls"].workingHours ||
        this.rows.controls[index]["controls"].workingHours.value == null ||
        this.rows.controls[index]["controls"].workingHours.value.toString() === ""
      ) {
        this.rows.controls[index]["controls"].workingHours.setErrors({
          incorrect: true,
        });
      }
      else if (
        this.workingHrsValuesArr[index] ===
        this.workingHrsValuesArr[index - 1] &&
        this.rows.controls[index]["controls"].outputLevel.value !=
        this.rows.controls[index - 1]["controls"].outputLevel.value
      ) {
        this.rows.controls[index]["controls"].outputLevel.setErrors({
          incorrect: true,
        });
      } else {
        const outputLevelValue = this.rows.controls[index]["controls"].outputLevel.value;
        const outputLevelMaximum = this.cloSchema["properties"]["CloPoint16"]["properties"]["Percentage"]["maximum"];

        if (outputLevelValue === null || isNaN(outputLevelValue) || outputLevelValue === "" ||
          outputLevelValue > outputLevelMaximum) {
          this.rows.controls[index]["controls"].outputLevel.setErrors({
            incorrect: true,
          });
        } else {
          this.rows.controls[index]["controls"].outputLevel.setErrors(null);

        }
      }
      if (this.workingHrsValuesArr[index] === "") {
        this.rows.controls[index]["controls"].workingHours.setErrors({
          incorrect: true,
        });
      }
      const valueEnteredCheck = this.workingHrsValuesArr[index];

      if (Number.isNaN(Number(valueEnteredCheck))) {
        this.rows.controls[index]["controls"].workingHours.setErrors({
          incorrect: true,
        });
      }
      if (index !== this.workingHrsValuesArr.length - 1) {
        if (
          this.workingHrsValuesArr[index] > this.workingHrsValuesArr[index + 1]
        ) {
          this.isAscending = false;
          this.rows.controls[index + 1]["controls"].workingHours.setErrors({
            incorrect: true,
          });
        } else if (this.workingHrsValuesArr[index] === "") {
          this.rows.controls[index]["controls"].workingHours.setErrors({
            incorrect: true,
          });
        } else if (Number.isNaN(Number(valueEnteredCheck))) {
          this.rows.controls[index]["controls"].workingHours.setErrors({
            incorrect: true,
          });
        } else {
          const nextVal = this.rows.controls[index + 1]["controls"].workingHours.value;
          if (nextVal !== null && nextVal !== "" && nextVal !== undefined) {
            this.rows.controls[index + 1]["controls"].workingHours.setErrors(null);
          }
        }
      }
    });

    if (!this.isAscending) {
      setTimeout(() => {
        this.setCloValid("invalid");
        this.disableAddBtn = true;
      }, 0);
    } else {
      //NO Error
      for (let r = 0; r < this.rows.length; r++) {
        // this.rows.controls[r]['controls'].workingHours.setErrors(null);
      }

      this.disableAddBtn = false;
      if (this.rowLength === 16) {
        this.disableAddBtn = true;
      }
    }
    // }, 0);
  }
  //Enter Table Invalid Data Check - ends here

  checkAddesRowValuesChanged(index) {
    //Not numeric generated, value changes/added row show graph - Starts Here
    // Safety check: ensure the row exists before setting up subscriptions
    if (!this.rows.controls[index]) {
      return;
    }
    this.rows.controls[index]["controls"].workingHours.valueChanges.subscribe(
      (value) => {
        this.isGraphDragUpdate = false;
        this.defaultColor = false;
        this.featureDefaults.setCloDefaultColor(this.defaultColor);
        if (!this.isValuesNumericGenerated) {
          for (const key of Object.keys(this.f)) {
            this.f[key].setValue("");
          }
        } //clear numeric generator fields - starts here
        this.submitted = false;
        this.isTableValuesChanged = true; //clear numeric generator fields - ends here
        this.tableValueSubmit = true;
        // Immediately reflect invalid state without waiting for setTimeout
        if (!this.addForm.valid) {
          this.setCloValid("invalid");
          this.cdRef.markForCheck();
        }
        this.updateCloTableValidation(index);
      }
    );
    this.rows.controls[index]["controls"].outputLevel.valueChanges.subscribe(
      (value) => {
        // Guard: the row at `index` may have been removed (e.g. via
        // onRemoveRow / rows.clear) between the time the subscription was
        // set up and the time valueChanges emits.
        if (!this.rows.controls[index]) {
          return;
        }
        if (
          this.rows.controls[index - 1] != null &&
          this.rows.controls[index]["controls"].workingHours.value ===
          this.rows.controls[index - 1]["controls"].workingHours.value &&
          this.rows.controls[index]["controls"].outputLevel.value !=
          this.rows.controls[index - 1]["controls"].outputLevel.value
        ) {
          this.rows.controls[index]["controls"].outputLevel.setErrors({
            incorrect: true,
          });
        } else {
          const outputLevelValue = this.rows.controls[index]["controls"].outputLevel.value;
          const outputLevelMaximum = this.cloSchema["properties"]["CloPoint16"]["properties"]["Percentage"]["maximum"];

          if (outputLevelValue === null || isNaN(outputLevelValue) || outputLevelValue === "" ||
            outputLevelValue > outputLevelMaximum) {
            this.rows.controls[index]["controls"].outputLevel.setErrors({
              incorrect: true,
            });
          } else {
            if (this.rows.controls[index] != null) {
              this.rows.controls[index]["controls"].outputLevel.setErrors(null);
            }
          }
        }


        this.isGraphDragUpdate = false;
        this.defaultColor = false;
        this.featureDefaults.setCloDefaultColor(this.defaultColor);
        if (!this.isValuesNumericGenerated) {
          for (const key of Object.keys(this.f)) {
            this.f[key].setValue("");
          }
        } //clear numeric generator fields - starts here
        this.submitted = false;
        this.isTableValuesChanged = true; //clear numeric generator fields - ends here
        this.tableValueSubmit = true;
        // Immediately reflect invalid state without waiting for setTimeout
        if (!this.addForm.valid) {
          this.setCloValid("invalid");
          this.cdRef.markForCheck();
        }
        this.updateCloTableValidation(index);
      }
    ); //Not numeric generated, value changes/added row show graph - Ends Here
    this.checkActualCloPoints();
  }

  /** Shared deferred validation + graph-update logic run after any table cell changes. */
  private updateCloTableValidation(index: number): void {
    setTimeout(() => {
      if (this.addForm.valid) {
        this.dataToShow = [];
        for (let r = 0; r < this.rows.length; r++) {
          this.dataToShow.push({
            hour: this.rows.controls[r]["controls"].workingHours.value,
            power: this.rows.controls[r]["controls"].outputLevel.value,
          });
        }
        this.graphState.sendGraphIsEditedData(this.dataToShow);
        this.graphState.sendCloGraphData(
          this.graphRepresentationType,
          this.dataToShow
        );
        if (this.rowLength === 16) {
          this.disableAddBtn = true;
        } else {
          this.disableAddBtn = false;
        }
        if (!this.isGraphDragUpdate) {
          //Enter Table Invalid Data Check - starts here
          this.checkWorkingHrsValuesOrder(index);
        }
      } else {
        if (!this.isGraphDragUpdate) {
          this.checkWorkingHrsValuesOrder(index);
          this.setCloValid("invalid");
          this.disableAddBtn = true;
        }
      }
      if (!this.isGraphDragUpdate) {
        setTimeout(() => {
          if (this.addForm.valid) {
            this.setCloValid("");
            this.dataToShow = [];
            for (let r = 0; r < this.rows.length; r++) {
              this.dataToShow.push({
                hour: this.rows.controls[r]["controls"].workingHours.value,
                power: this.rows.controls[r]["controls"].outputLevel.value,
              });
            }
            this.graphState.sendGraphIsEditedData(this.dataToShow);
            this.graphState.sendCloGraphData(
              this.graphRepresentationType,
              this.dataToShow
            );
          }
        }, 0);
      } //Enter Table Invalid Data Check - ends here
    }, 0);
    setTimeout(() => {
      if (this.addForm.valid) {
        this.disableAddAboveBtn = false;
        this.disableAddBelowBtn = false;
        this.setCloValid("valid");
        // Check if the changed values match defaults
        setTimeout(() => {
          this.checkFinalDefaultTable();
        }, 150);
      } else {
        this.disableAddAboveBtn = true;
        this.disableAddBelowBtn = true;
        this.setCloValid("invalid");
      }
    }, 100);
  }
  onRemoveRow(rowIndex: number) {
    if(this.disableGraph) {
      return;
    }
    this.defaultColor = false;
    this.featureDefaults.setCloDefaultColor(this.defaultColor);

    if (!this.isNumericCreatedRows) {
      this.rows.removeAt(rowIndex);
      this.rowLength = this.rows.length;
      this.validateAfterRowRemoval(rowIndex);
    }
    if (this.isNumericCreatedRows) {

      this.modalService.confirm('Values are changed from the numeric generator. Are you sure you want to proceed', "Confirm", true).pipe(take(1))
        .subscribe(confirm => {
          if (confirm) {
            this.unsubscribe.next(undefined);
            this.isNumericCreatedRows = false;
            this.rows.removeAt(rowIndex);
            this.rowLength = this.rows.length;
            for (const key of Object.keys(this.f)) {
              this.f[key].setValue("");
            }
            this.submitted = false;
            this.isTableValuesChanged = true;
            this.validateAfterRowRemoval(rowIndex);
          } else {
            return;
          }
        }
      );

    }

  }

  private validateAfterRowRemoval(rowIndex: number): void {
    this.tableValueSubmit = true;
    this.checkWorkingHrsValuesOrder(rowIndex);
    this.refreshAddRowDisableFlags();
    this.cdRef.markForCheck();
    setTimeout(() => {
      this.checkWorkingHrsValuesOrder(rowIndex);
      this.refreshAddRowDisableFlags();
      this.cdRef.markForCheck();
      if (this.addForm.valid) {
        this.setCloValid("valid");
        this.dataToShow = []; // remove row update grapg - starts here
        for (let r = 0; r < this.rows.length; r++) {
          this.dataToShow.push({
            hour: this.rows.controls[r]["controls"].workingHours.value,
            power: this.rows.controls[r]["controls"].outputLevel.value,
          });
        }
        this.graphState.sendCloGraphData(
          this.graphRepresentationType,
          this.dataToShow
        ); // remove row update grapg - ends here
      } else {
        this.setCloValid("invalid");
      }
    }, 0);
    this.checkActualCloPoints();
    // Check if after removal the values match defaults
    setTimeout(() => {
      this.checkFinalDefaultTable();
    }, 150);
  }

  createItemFormGroup(): FormGroup {
    const rowForm = this.fb.group({
      workingHours: [
        null,
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.min(0),
          Validators.max(120),
        ],
      ],
      outputLevel: [
        null,
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.min(0),
          Validators.max(100),
        ],
      ],
    });
    rowForm.get('workingHours')?.addValidators(control => this.validateWorkingHoursOrder(control));
    return rowForm;
  }

  private validateWorkingHoursOrder(control: AbstractControl): ValidationErrors | null {
    if (!control.parent) {
      return null;
    }
    const rowIndex = this.rows.controls.indexOf(control.parent);
    const currentHour = Number(control.value);
    if (rowIndex === 0 && currentHour !== 0) {
      return { incorrect: true };
    }
    const previousHour = this.rows.at(rowIndex - 1)?.get('workingHours')?.value;
    if (rowIndex > 0 && Number(previousHour) > currentHour) {
      return { incorrect: true };
    }
    return null;
  }

  checkIfValueEntered() {
    if (this.registerForm.valid && !this.fileResponse["resp"]) {
      this.setCloValid("valid");
    } else if (!this.registerForm.valid) {
      this.setCloValid("invalid");
    }
    for (const key of Object.keys(this.f)) {
      //check LegacyAny one value entered
      if (this.f[key].value === "") {
        this.fewFieldValuePresent = false;
      } else {
        this.fewFieldValuePresent = true;
        this.submitted = true;
        break;
      }
    }
    this.checkActualCloPoints();
  }

  reInitializeValue() {
    if (!this.isNumericCreatedRows) {
      this.rows.clear();
      // Limit to maximum 16 rows
      const itemsToAdd = this.dataToShow.slice(0, 16);
      itemsToAdd.forEach((content, index) => {
        this.onAddRow();
        this.checkAddesRowValuesChanged(index);
      });
    }
    if (this.isGraphUpdated) {
      this.dataToShow.forEach((content, index) => {
        if (this.rows.controls[index]) {
          this.rows.controls[index]["controls"].workingHours.setValue(
            content.hour
          );
          this.rows.controls[index]["controls"].outputLevel.setValue(
            content.power
          );
        }
      });
    }

    if (!this.isGraphUpdated) {
      this.dataToShow.forEach((content, index) => {
        if (index !== this.dataToShow.length - 1 && this.rows.controls[index]) {
          this.rows.controls[index]["controls"].workingHours.setValue(
            content.hour
          );
          this.rows.controls[index]["controls"].outputLevel.setValue(
            content.power
          );
        }
      });
    }
    this.checkActualCloPoints();
  }

  verifyTableValueChange() {
    this.clonedDataToShow = Object.assign([], this.dataToShow);
    if (this.isNumericCreatedRows && this.Steps < this.dataToShow.length) {
      this.dataToShow.pop();
    }
    this.dataToShow.forEach((content, index) => {
      this.rows.controls[index]["controls"].workingHours.valueChanges
        .pipe(startWith(content.hour), pairwise())
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([prev, next]: [LegacyAny, LegacyAny]) => {
          if (prev !== next) {
            this.modalService.confirm('Values are changed from the numeric generator. Are you sure you want to proceed', "Confirm", true).pipe(take(1))
              .subscribe(confirm => {
                if (confirm) {
                  this.unsubscribe.next(undefined);
                  for (const key of Object.keys(this.f)) {
                    this.f[key].setValue("");
                  }
                  this.submitted = false;
                  this.isTableValuesChanged = true;
                  this.isNumericCreatedRows = false;
                } else {
                  this.unsubscribe.next(undefined);
                  this.isTableValuesChanged = false;
                  const tempData = this.clonedDataToShow;
                  this.rows.clear();
                  setTimeout(() => {
                    for (let n = 0; n <= this.Steps - 1; n++) {
                      this.rows.push(this.createItemFormGroup());
                    }
                    this.rowLength = this.rows.length;
                    this.dataToShow = [];
                    this.dataToShow = tempData;
                    this.reInitializeValue();
                    for (let n = 0; n <= this.Steps - 1; n++) {
                      this.checkAddesRowValuesChanged(n);
                    }
                    this.verifyTableValueChange();
                  }, 0);
                  // this.rows.controls[index]['controls'].workingHours.setValue(content.hour,{ onlySelf: true });
                }
              }
              );
          }
        });
      this.rows.controls[index]["controls"].outputLevel.valueChanges
        .pipe(startWith(content.power), pairwise())
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([prev, next]: [LegacyAny, LegacyAny]) => {
          if (prev !== next) {
            this.modalService.confirm('Values are changed from the numeric generator. Are you sure you want to proceed', "Confirm", true).pipe(take(1))
              .subscribe(confirm => {
                if (confirm) {
                  this.unsubscribe.next(undefined);
                  for (const key of Object.keys(this.f)) {
                    this.f[key].setValue("");
                  }
                  this.submitted = false;
                  this.isTableValuesChanged = true;
                  this.isNumericCreatedRows = false;
                } else {
                  this.unsubscribe.next(undefined);
                  this.isTableValuesChanged = false;
                  const tempData = this.clonedDataToShow;
                  this.rows.clear();
                  setTimeout(() => {
                    for (let n = 0; n <= this.Steps - 1; n++) {
                      this.rows.push(this.createItemFormGroup());
                    }
                    this.rowLength = this.rows.length;
                    this.dataToShow = [];
                    this.dataToShow = tempData;
                    this.reInitializeValue();
                    for (let n = 0; n <= this.Steps - 1; n++) {
                      this.checkAddesRowValuesChanged(n);
                    }
                    this.verifyTableValueChange();
                  }, 0);
                }
              }
              );
          }
        });
      // }
    });
    this.checkActualCloPoints();
  }

  confirmResetFields() {


    this.modalService.confirm('Action not complete or invalid entry. Values will be reset. Do you want to continue?', "Confirm", true).pipe(take(1))
      .subscribe(confirm => {
        if (confirm) {
          setTimeout(() => {
            for (const key of Object.keys(this.f)) {
              this.f[key].setValue("");
            }
            this.submitted = false;
            // Reset the generator and table only; Restore default (setDefaultGraph) would also disable the feature.
            this.clearNumericFields("default", true);
            this.activeIdString = "2";
            this.cdRef.markForCheck();
          }, 0);

        } else {
          return;
        }
        this.checkActualCloPoints();

      }
      );
  }


  clearTableValueFields() {
    if(this.disableGraph){
      return;
    }
    this.fileResponse = "";
    if (this.isNumericCreatedRows || this.rows.length > 1 || this.dataToShow.length > 1) {
      this.modalService.confirm('Values are changed from the numeric generator. Are you sure you want to proceed', "Confirm", true).pipe(take(1))
        .subscribe(confirm => {
          if (confirm) {
            this.clearFields = true;
            this.clearValues();
            this.disableAddAboveBtn = false;
            this.disableAddBelowBtn = false;
            this.checkActualCloPoints();
          } else {
            return;
          }
        }
        );
    }

  }

  clearValues() {
    this.unsubscribe.next(undefined);
    this.isNumericCreatedRows = false;
    this.rows.clear();
    this.onAddRow();
    this.dataToShow = [];
    this.dataToShow.push({
      hour: this.cloSchema["properties"]["CloPoint1"]["properties"]["Time"][
        "const"
      ],
      power:
        this.cloSchema["properties"]["CloPoint1"]["properties"]["Percentage"][
        "default"
        ],
    });
    this.rows.controls[0]["controls"].workingHours.setValue(
      this.cloSchema["properties"]["CloPoint1"]["properties"]["Time"]["const"]
    );
    this.rows.controls[0]["controls"].outputLevel.setValue(
      this.cloSchema["properties"]["CloPoint1"]["properties"]["Percentage"][
      "default"
      ]
    );
    this.defaultColor = false;
    this.featureDefaults.setCloDefaultColor(this.defaultColor);

    this.graphState.sendGraphIsEditedData([
      {
        hour: this.cloSchema["properties"]["CloPoint1"]["properties"]["Time"][
          "const"
        ],
        power:
          this.cloSchema["properties"]["CloPoint1"]["properties"]["Percentage"][
          "default"
          ],
      },
    ]);
    // this.graphState.sendGraphIsEditedData([{ hour: 0, power: 100 }]);
    this.graphState.sendCloGraphData(
      this.graphRepresentationType,
      this.dataToShow
    );
    for (const key of Object.keys(this.f)) {
      this.f[key].setValue("");
    }
    this.tableValueSubmit = false;
    this.isTableValuesChanged = false;
    this.checkAddesRowValuesChanged(this.rows.length - 1);
    this.checkActualCloPoints();
    this.refreshAddRowDisableFlags();
    this.cdRef.markForCheck();
  }
    private applyGraphDisabledState(): void {
    if (!this.registerForm) {
      return;
     }
    if (this.registerForm.disabled) {
      this.registerForm.enable({ emitEvent: false });
    }
    if (this.addForm.disabled) {
      this.addForm.enable({ emitEvent: false });
    }
  }

  enableGraph(value) {
    this.disableGraph = !value;
    this.defaultColor = !value;
    if (this.disableGraph) {
      this.enableChecked = false;
    } else {
      this.enableChecked = true;
    }
    this.applyGraphDisabledState();

    if (this.enableChecked || this.rows.length !== 16 || this.hasInvalidCloInput()) {
      this.defaultColor = false;
    }
    this.graphState.setEnableGraph(value);
    this.featureDefaults.setCloDefaultColor(this.defaultColor);
    setTimeout(() => {
      for (let i = 0; i < this.rows.length; i++) {
        this.checkAddesRowValuesChanged(i);
      }
      for (let i = 0; i < this.rows.length; i++) {
        this.checkWorkingHrsValuesOrder(i);
      }
      if (!this.addForm.valid) {
        this.disableAddBtn = true;
        this.setCloValid("invalid");
      } else {
        this.disableAddBtn = this.rowLength >= 16;
        this.setCloValid("valid");
      }
    }, 100);
  }

  setDefaultGraph(restoreDefaultStatus = "default") {
    if (!this.disableGraph) {
      this.fileResponse = "";
      this.enableChecked = false;
      this.disableGraph = true;
      this.graphState.setEnableGraph(false);
      this.activeIdString = "2";
      this.unsubscribe.next(undefined);
      this.isNumericCreatedRows = false;
      this.rows.clear();
      this.dataToShow = [];

      for (let i = 1; i <= 16; i++) {
        this.onAddRow(restoreDefaultStatus);
      }

      for (let i = 1; i <= 16; i++) {
        const cloPoint = this.cloSchema["properties"]["CloPoint" + i];
        if (cloPoint && this.rows.controls[i - 1]) {
          const workingHoursValue = (i === 1)
            ? cloPoint["properties"]["Time"]["const"]
            : cloPoint["properties"]["Time"]["default"];
          this.rows.controls[i - 1]["controls"].workingHours.setValue(workingHoursValue);
          this.rows.controls[i - 1]["controls"].outputLevel.setValue(
            cloPoint["properties"]["Percentage"]["default"]
          );
          this.dataToShow.push({
            hour: workingHoursValue,
            power: cloPoint["properties"]["Percentage"]["default"],
          });
        }
      }
      this.defaultColor = true;
      this.featureDefaults.setCloDefaultColor(this.defaultColor);

      const saveSetData = this.appState.getSaveSetData();
      const configData = this.appState.getConfigurationData();
      const defaultCloData: LegacyAny = {
        CloEnabled: false
      };

      for (let i = 1; i <= 16; i++) {
        const cloPoint = this.cloSchema["properties"]["CloPoint" + i];
        if (cloPoint) {
          const workingHoursValue = (i === 1)
            ? cloPoint["properties"]["Time"]["const"]
            : cloPoint["properties"]["Time"]["default"];
          defaultCloData["CloPoint" + i] = {
            Time: workingHoursValue,
            Percentage: cloPoint["properties"]["Percentage"]["default"]
          };
        }
      }

      // Update SaveSetData
      if (saveSetData && saveSetData["resp"]) {
        saveSetData["resp"]["CLO"] = defaultCloData;
        this.appState.setSaveSetData(saveSetData);
      }

      // Update ConfigurationData
      if (configData && configData["resp"]) {
        configData["resp"]["CLO"] = defaultCloData;
        this.appState.setConfigurationData(configData);
      }

      this.graphState.sendGraphIsEditedData(this.dataToShow);
      this.graphState.sendCloGraphData(this.graphRepresentationType, this.dataToShow);

      for (const key of Object.keys(this.f)) {
        this.f[key].setValue("", { emitEvent: false });
        this.f[key].markAsPristine();
        this.f[key].markAsUntouched();
      }

      this.submitted = false;
      this.disableNumericClear = true;

      this.tableValueSubmit = false;
      this.isTableValuesChanged = false;
      for (let i = 0; i < this.rows.length; i++) {
        this.checkAddesRowValuesChanged(i);
      }
      setTimeout(() => {
        for (let i = 0; i < this.rows.length; i++) {
          this.checkWorkingHrsValuesOrder(i);
        }
        if (!this.addForm.valid) {
          this.setCloValid("invalid");
          this.disableAddBtn = true;
        } else {
          this.setCloValid("valid");
          this.disableAddBtn = this.rowLength >= 16;
        }
        this.applyGraphDisabledState();
      }, 100);
  } else {
    this.enableChecked = true;
  }
    this.defaultColor = true;
    this.featureDefaults.setCloDefaultColor(this.defaultColor);

    this.checkActualCloPoints();
    this.alldefault=true;
  }


  AddRow() {
    if(this.disableGraph) {
      return;
    }
    this.tableValueSubmit = true;
    const wasNumericCreated = this.isNumericCreatedRows;
    this.onAddRow();
    // Only set up subscriptions here if not numeric-created
    // (numeric-created case is handled inside onAddRow's modal callback)
    if (!wasNumericCreated) {
      this.checkAddesRowValuesChanged(this.rows.length - 1);
      this.checkActualCloPoints();
    }
    this.defaultColor = false;
    this.featureDefaults.setCloDefaultColor(this.defaultColor);
    this.alldefault=false;

  }

  RemoveRow(index) {
    this.onRemoveRow(index);
  }
  onRightClick($event, index) {
    if(this.disableGraph) {
      this.menuState = false;
      return;
    }
    this.selectedRow = index;
    $event.stopPropagation();
    this.menuState = true;
    this.positionMenu(event);

    if (this.rowLength === 16 || this.rowLength > 16) {
      this.disableAddBtn = true;
      this.disableAddAboveBtn = true;
      this.disableAddBelowBtn = true;
    }
  }

  getPosition(e) {
    let posx = 0;
    let posy = 0;
    if (e.pageX || e.pageY) {
      posx = e.pageX;
      posy = e.pageY;
    } else if (e.clientX || e.clientY) {
      posx =
        e.clientX +
        document.body.scrollLeft +
        document.documentElement.scrollLeft;
      posy =
        e.clientY +
        document.body.scrollTop +
        document.documentElement.scrollTop;
    }
    return { x: posx, y: posy };
  }

  positionMenu(e) {
    this.menuPosition = this.getPosition(e);
    this.menuPositionX = this.menuPosition.x;
    this.menuPositionY = this.menuPosition.y;
    this.cdRef.detectChanges();
    this.menuWidth = this.contextMenu.nativeElement.offsetWidth;
    this.menuHeight = this.contextMenu.nativeElement.offsetHeight;
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
    if (Math.abs(this.windowWidth - this.menuPositionX) < this.menuWidth) {
      this.menuPositionX = this.windowWidth - this.menuWidth - 250 + "px";
    } else {
      //this.menuPositionX = this.menuPositionX - 250+ "px";
      this.menuPositionX = 190 + "px";
    }
    if (Math.abs(this.windowHeight - this.menuPositionY) < this.menuHeight) {
      this.menuPositionY = this.windowHeight - this.menuHeight - 50 + "px";
    } else {
      this.menuPositionY = this.menuPositionY - 50 + "px";
    }
  }
  @HostListener("document:click", ["$event"])
  public documentClick(event: Event): void {
    this.menuState = false;
  }
  @HostListener("document:contextmenu", ["$event"])
  public documentRClick(event: Event): void {
    this.menuState = false;
  }

  addRowAbove() {
    this.addRowAtInsertPosition(this.selectedRow);
  }

  addRowBelow() {
    this.addRowAtInsertPosition(this.selectedRow + 1);
  }

  /**
   * Shared body for addRowAbove/addRowBelow. Inserts a fresh row-form-group
   * at `insertPosition`, updates row length and the various disable flags,
   * and rewires the value-change subscription for the new row. When
   * numeric-generated rows are in play, a confirmation modal precedes the
   * insertion.
   */
  private addRowAtInsertPosition(insertPosition: number): void {
    if (this.disableGraph || this.rowLength >= 16) {
      return;
    }
    this.defaultColor = false;
    this.featureDefaults.setCloDefaultColor(this.defaultColor);

    if (!this.isNumericCreatedRows) {
      this.tableValueSubmit = true;
      this.rows.insert(insertPosition, this.createItemFormGroup());
      this.rowLength = this.rows.length;
      setTimeout(() => this.refreshAddRowDisableFlags(), 0);
      this.checkAddesRowValuesChanged(insertPosition);
      this.checkActualCloPoints();
    }

    if (this.isNumericCreatedRows) {
      this.modalService
        .confirm(
          'Values are changed from the numeric generator. Are you sure you want to proceed',
          "Confirm",
          true
        )
        .pipe(take(1))
        .subscribe(confirm => {
          if (confirm) {
            this.unsubscribe.next(undefined);
            this.isNumericCreatedRows = false;
            this.rows.insert(insertPosition, this.createItemFormGroup());
            this.rowLength = this.rows.length;
            for (const key of Object.keys(this.f)) {
              this.f[key].setValue("");
            }
            this.submitted = false;
            this.isTableValuesChanged = true;
          } else {
            return;
          }
          setTimeout(() => this.refreshAddRowDisableFlags(), 0);
          this.checkAddesRowValuesChanged(insertPosition);
          this.checkActualCloPoints();
        });
    }
  }

  /**
   * Recomputes disableAddBtn / disableAddAboveBtn / disableAddBelowBtn based
   * on current row count (16 max) and the addForm's validity, and updates
   * graphState with the corresponding valid/invalid signal. Formerly
   * inlined twice inside addRowAbove and twice inside addRowBelow.
   */
  private refreshAddRowDisableFlags(): void {
    if (this.rowLength >= 16) {
      this.disableAddBtn = true;
      this.disableAddAboveBtn = true;
      this.disableAddBelowBtn = true;
    } else {
      this.disableAddBtn = false;
      this.disableAddAboveBtn = false;
      this.disableAddBelowBtn = false;
    }
    if (!this.addForm.valid) {
      this.disableAddBtn = true;
      this.disableAddAboveBtn = true;
      this.disableAddBelowBtn = true;
      this.setCloValid("invalid");
    } else {
      this.disableAddBtn = false;
      this.disableAddAboveBtn = false;
      this.disableAddBelowBtn = false;
      this.setCloValid("valid");
    }
  }
  clearNumericFields(restoreDefaultStatus = "default", isClearFields=false) {
    if(this.disableGraph) {
      return;
    }
    this.clearFields=isClearFields;
    this.disableNumericClear = true;
    for (const key of Object.keys(this.f)) {
      this.f[key].setValue("");
    }
    this.unsubscribe.next(undefined);
    this.isNumericCreatedRows = false;
    this.rows.clear();
    this.dataToShow = [];

    for (let i = 1; i <= 16; i++) {
      this.onAddRow(restoreDefaultStatus);
      const cloPoint = this.cloSchema["properties"]["CloPoint" + i];
      if (cloPoint && this.rows.controls[i - 1]) {
        const workingHoursValue = (i === 1)
          ? cloPoint["properties"]["Time"]["const"]
          : cloPoint["properties"]["Time"]["default"];
        this.rows.controls[i - 1]["controls"].workingHours.setValue(workingHoursValue);
        this.rows.controls[i - 1]["controls"].outputLevel.setValue(
          cloPoint["properties"]["Percentage"]["default"]
        );
        this.dataToShow.push({
          hour: workingHoursValue,
          power: cloPoint["properties"]["Percentage"]["default"],
        });
      }
    }

    if (this.enableChecked) {
      this.defaultColor = false;
    } else {
      this.defaultColor = true;
    }
    this.featureDefaults.setCloDefaultColor(this.defaultColor);

    this.graphState.sendGraphIsEditedData(this.dataToShow);
    this.graphState.sendCloGraphData(
      this.graphRepresentationType,
      this.dataToShow
    );
    this.tableValueSubmit = false;
    this.isTableValuesChanged = false;

    for (let i = 0; i < this.rows.length; i++) {
      this.checkAddesRowValuesChanged(i);
    }

    // Ensure button is disabled when we have 16 rows
    setTimeout(() => {
      if (this.rowLength >= 16) {
        this.disableAddBtn = true;
      }
    }, 0);

    this.afterClearField = true;
    this.checkActualCloPoints();
  }
  @HostListener('window:beforeunload')
  saveEditorDraft(): void {
    if (!this.registerForm || !this.cloSchema?.properties?.CloPoint16) {
      return;
    }
    this.appState.saveCloEditorDraft({
      activeTab: this.activeIdString,
      numeric: this.registerForm.getRawValue(),
      rows: this.rows.getRawValue(),
      graphPoints: this.dataToShow,
      enabled: this.enableChecked,
      numericCreated: this.isNumericCreatedRows,
      tableChanged: this.isTableValuesChanged,
      submitted: this.submitted,
      tableSubmitted: this.tableValueSubmit,
      defaultColor: this.defaultColor
    });
  }

  private restoreEditorDraft(draft: CloEditorDraft): void {
    this.fileResponse = '';
    this.activeIdString = draft.activeTab;
    this.registerForm.setValue(draft.numeric, { emitEvent: false });
    this.rows.clear();
    draft.rows.forEach(values => {
      const row = this.createItemFormGroup();
      row.setValue(values, { emitEvent: false });
      this.rows.push(row);
    });
    this.rowLength = this.rows.length;
    this.dataToShow = draft.graphPoints;
    this.enableChecked = draft.enabled;
    this.disableGraph = !draft.enabled;
    this.isNumericCreatedRows = draft.numericCreated;
    this.isValuesNumericGenerated = draft.numericCreated;
    this.Max = Number(draft.numeric.cloHour);
    this.Steps = Number(draft.numeric.cloSteps);
    this.Initial = Number(draft.numeric.initialOutput);
    this.Final = Number(draft.numeric.finalOutput);
    this.isTableValuesChanged = draft.tableChanged;
    this.submitted = draft.submitted;
    this.tableValueSubmit = draft.tableSubmitted;
    this.defaultColor = draft.defaultColor;
    this.alldefault = draft.defaultColor;
    this.disableNumericClear = !this.hasNumericGeneratorInput();
    this.rows.controls.forEach((row, index) => this.checkAddesRowValuesChanged(index));
    if (draft.numericCreated) {
      this.verifyTableValueChange();
    }
    this.checkWorkingHrsValuesOrder(0);
    this.refreshAddRowDisableFlags();
    this.graphState.setEnableGraph(draft.enabled);
    this.graphState.sendCloGraphData(this.graphRepresentationType, this.dataToShow);
  }

  ngOnDestroy() {
    this.unsubscribeGraphType.next(undefined);
    this.unsubscribeNumeric.next(undefined);
    this.graphState.sendCloGraphData("", []);
    this.clo.setCloLoadConfigureExtraValidation("");
    if(this.getCloLoadFeatureFileConfigureSub) this.getCloLoadFeatureFileConfigureSub.unsubscribe();
  }
}
